import { ContentServiceMock } from './contents/ContentServiceMock';
import { ContentServiceApi } from './contents/ContentServiceApi';
import { IContentService } from './contents/IContentService';
import { IUserService } from './user/IUserService';
import { UserServiceMock } from './user/UserServiceMock';
import { UserServiceApi } from './user/UserServiceApi';
import { IUserDataService } from './userData/IUserDataService';
import { UserDataServiceMock } from './userData/UserDataServiceMock';
import { UserDataServiceApi } from './userData/UserDataServiceApi';

let mockEnabled:boolean = false;

const ContentService: IContentService = mockEnabled ? new ContentServiceMock() : new ContentServiceApi();
const UserService:IUserService = mockEnabled ? new UserServiceMock() : new UserServiceApi();
const UserDataService:IUserDataService = mockEnabled ? new UserDataServiceMock() :  new UserDataServiceApi();

export
{
    ContentService,
    UserService,
    UserDataService
}